<span [innerHTML]="iconHtml$ | async"></span>
